module.exports = __webpack_public_path__ + "img/works_ssFire_btm.22eef783.jpg";